import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const select = css`
  & input[type='text'] {
    padding-inline-end: ${spacing(7)};
    text-overflow: ellipsis;
  }
`
export const button = css`
  margin-inline-end: ${spacing(7)};
`
export const label = css`
  display: inline-block;
  margin-inline-end: ${spacing(2)};
  max-inline-size: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
